import { lazy } from 'react';

/** Загружает страницу диагностики памяти по требованию */
export const MemoryDiagnosticsPageAsync = lazy(() => import('./MemoryDiagnosticsPage'));
